function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "tube");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M258,115.79A129.31,129.31,0,0,0,28.84,48.06a129.39,129.39,0,0,0,100.35,210.7A130.7,130.7,0,0,0,143,258,129.5,129.5,0,0,0,258,115.79Zm-58,70.72A90.84,90.84,0,1,1,119.83,39a92.79,92.79,0,0,1,9.69-.51,90.85,90.85,0,0,1,70.49,148Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.08,76.59a67.83,67.83,0,1,0,24.85,45.65A67.45,67.45,0,0,0,172.08,76.59ZM169,161.43a51,51,0,1,1-45-82.75h0a50.63,50.63,0,0,1,36.85,10.65L155.3,96a3.92,3.92,0,0,0-.14,5.53l4.4,4.63a3.92,3.92,0,0,0,5.53.14l6.63-5.3A50.89,50.89,0,0,1,169,161.43Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 147.6,
  y: 103.61,
  width: 7.87,
  height: 12.5,
  rx: 2.57,
  transform: "translate(-33.99 134.62) rotate(-43.54)"
})));

var SvgTube = function SvgTube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 258.76 258.76",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tube.b11ed2c4.svg";
export { ForwardRef as ReactComponent };